console.log('Custom-Prasi-JS');
$(function() {
    
    var isMobile = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i);
    
    // Menu
    //$('#header-dropdown-families>li').hover(function() {
    $('.dropdown-wrap.primary.dropdown-right>li').hover(function() {
        let target = $(this).attr('target');
        console.log(target);
        $('.submenu-collection-image').removeClass('active')
        $(target).addClass('active');
    });

    // Filtros
    var els = document.getElementsByClassName("collection-filters__filter-group-title");
    Array.prototype.forEach.call(els, function(el) {
        var clone = el.cloneNode(true); 
        el.replaceWith(clone);
    })

    // $('.collection-filters__filter-group-title').click( function(){
    //     $(this).parent().children('.collection-filters__filter').slideToggle("fast", "swing");
    // } );

    // Toggle filtros mobile
    $('label.collection__filters-title.sidebar-title').click(function(){
        $(".collection__filters").slideToggle("fast","linear");
    })
        
    

    // Zoom / Slider (mobile) fotos Produtos
    if( $('.product-gallery').length ){
        
        // $(function() {
        //     $( ".product-gallery--media-wrapper" ).each(function( index ) {
        //         urlImagem = $(this).children('img').attr('src');
        //         console.log(urlImagem);
        //         $(this).zoom({url: urlImagem});
        //     });
        // });
          
        if( isMobile ){
            $(function() {
                $( ".product-gallery--media-wrapper" ).each(function( index ) {
                    urlImagem = $(this).children('img').attr('src');
                    console.log(urlImagem);
                    $(this).zoom({url: urlImagem});
                });
            });

            $('.product-gallery--viewport').slick({
                lazyLoad: 'ondemand',
                swipe: false,
            });
        } else {
            
            // zoom só na primeira foto
            $(function() {
                var primeiraFoto = $('.product-gallery--viewport--figure')[0];
                
                    urlImagem = $(primeiraFoto).children('img').attr('src');
                    console.log(urlImagem);
                    $(primeiraFoto).zoom({url: urlImagem});
                
            });
            
            // Troca a foto de cima quando clica
            var primeiraFoto = $('.product-gallery--viewport--figure')[0];
            $('.product-gallery--viewport--figure').click( function(){
                // var primeiraFoto = $('.product-gallery--viewport--figure')[0];
                // $(primeiraFoto).trigger('zoom.destroy');

                $('.product-gallery--viewport--figure').each(function( index ) {
                    $( this ).trigger('zoom.destroy');
                });

                $(primeiraFoto).attr('data-product-gallery-figure', $(this).attr('data-product-gallery-figure'))
                $('.product-gallery--viewport--figure').attr('data-product-gallery-selected', false).attr('aria-hidden', true)
                $(this).attr('data-product-gallery-selected', true).attr('aria-hidden', false).attr('data-product-gallery-figure', 0)
                $(this).parent().prepend(this);
                $(this).toggleClass('destaque');

                urlImagem = $(this).children('img').attr('src');
                $(this).zoom({url: urlImagem});
            } )

            // Coloca a foto da opção clicada na primeira posição
            var urlParams = new URLSearchParams(window.location.search);
            var idVariacaoSelecionada = urlParams.get('variant');
            console.log("idVariacaoSelecionada = " + idVariacaoSelecionada);

            $('.option-value-input').on('change input', function() {
                setTimeout(function() { // Agurada 100ms para que a URL do input seja atualizada
                    var params = new URLSearchParams(window.location.search);

                    // Obter o valor de um parâmetro específico
                    var variantId = params.get('variant');
                    console.log(variantId);
                    
                    if(idVariacaoSelecionada != variantId){
                        console.log('mudou a variacao3');
                        idVariacaoSelecionada = variantId;
                        var produto = Object.values(Theme.products)[0];
                        var variantEncontrada = produto.variants.find(variant => variant.id == variantId);
                        var featureMediaId = variantEncontrada.featured_media.id;
                        $('#product-gallery--media-' + featureMediaId).trigger('click');
                        
                    }
                }, 100);
            });
            
            // $('.option-value-input').click( function(){


            //     var params = new URLSearchParams(window.location.search);

            //     // Obter o valor de um parâmetro específico
            //     var variantId = params.get('variant');
            //     console.log(variantId);


            //     objSelect = $('select[name="id"]');
            //     selectedOption = objSelect.find("option").eq( $(this).attr('value_index')-1 )
                
            //     // Verifica a propriedade img-src na opção selecionada
            //     var mediaId = selectedOption.attr("feat-media");
            //     // if( !$('#product-gallery--media-' + mediaId).hasClass('destaque') )
            //         $('#product-gallery--media-' + mediaId).trigger('click');
                
            // } );


            
        }
    }

    
    // $('.press .image-gallery-open').click(function(){
        
    //     var modal = $('#image-gallery-modal--' + $(this).attr('data-section-id'));
        
    //     $(modal).children('ul').slick({
    //         lazyLoad: 'ondemand'
    //     });
    //     $(modal).addClass('active');
    //     console.log('#image-gallery-modal--' + $(this).attr('data-section-id'))
    // });

    $('.image-gallery-modal').click(function(e){
        if( e.target == this ){
            $(this).removeClass('active');
            $(this).children('ul').slick('unslick');
        }
    });

});
document.addEventListener('DOMContentLoaded', function () {
  var searchButton = document.querySelector('[data-live-search-button-search]');
  var liveSearch = document.querySelector('[data-live-search]');

  if (!searchButton || !liveSearch) return;

  searchButton.addEventListener('click', function () {
    document.documentElement.classList.add('live-search-visible');
    liveSearch.classList.remove('live-search-hidden');

    var input = liveSearch.querySelector('[data-live-search-input]');
    if (input) input.focus();
  });

  var closeButton = liveSearch.querySelector('[data-live-search-form-button-close]');

  if (closeButton) {
    closeButton.addEventListener('click', function () {
      liveSearch.classList.add('live-search-hidden');
      document.documentElement.classList.remove('live-search-visible');
    });
  }
});